import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "playground-root" }
const _hoisted_2 = { class: "playground-content" }
const _hoisted_3 = { class: "editor-content" }
const _hoisted_4 = { class: "messages" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RulesSettings = _resolveComponent("RulesSettings")!
  const _component_ESLintEditor = _resolveComponent("ESLintEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RulesSettings, {
        ref: "settings",
        rules: _ctx.rules,
        "onUpdate:rules": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rules) = $event)),
        parser: _ctx.parser,
        "onUpdate:parser": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.parser) = $event)),
        class: "rules-settings"
      }, null, 8, ["rules", "parser"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ESLintEditor, {
          modelValue: _ctx.code,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code) = $event)),
          rules: _ctx.rules,
          parser: _ctx.parser,
          class: "eslint-playground",
          onUpdateMessages: _ctx.onUpdateMessages
        }, null, 8, ["modelValue", "rules", "parser", "onUpdateMessages"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ol", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: msg.line + ':' + msg.column + ':' + msg.ruleId + '@' + i,
                class: _normalizeClass(["message", msg.ruleId && _ctx.getRule(msg.ruleId)!.classes])
              }, [
                _createTextVNode(" [" + _toDisplayString(msg.line) + ":" + _toDisplayString(msg.column) + "]: " + _toDisplayString(msg.message) + " (", 1),
                _createElementVNode("a", {
                  href: msg.ruleId && _ctx.getRule(msg.ruleId)!.url,
                  target: "_blank"
                }, _toDisplayString(msg.ruleId), 9, _hoisted_5),
                _cache[3] || (_cache[3] = _createTextVNode(") "))
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}